export default {
  missingItem: 'Faltou dar opinião sobre algum item',
  missingScore: 'Escolha uma nota de 0 à 10',
  missingScoreCSAT: 'Escolha uma nota de 1 à 5',
  missingScoreCES: 'Escolha uma nota de 1 à 7',
  surveyAlreadyDone: 'Esta avaliação já foi realizada',
  surveyAlreadyDoneDetails: 'Infelizmente não é possível realizar esta avaliação novamente.',
  surveyNotFound: 'Ops! Avaliação não encontrada',
  surveyNotFoundDetails:
    'Infelizmente ocorreu uma falha, mas não deixe de avaliar as próximas pesquisas. Sua opinião é muito importante para nós.',
  surveyExpired: 'O período para realizar esta avaliação expirou',
  surveyExpiredDetails: 'Infelizmente esta avaliação não está mais disponível.',
  surveyInvalidScore: 'Ops! Nota inválida',
  surveyInativeJourney: 'Ops! Avaliação não disponivel no momento',
  surveyInativeJourneyDetails: 'Avaliação não disponivel no momento',
  surveyInvalidScoreDetails: 'Você informou uma nota inválida para este tipo de pesquisa.',
};
